<nz-layout>
    <nz-content class="table-container">
        <div class="table-wrapper">
            <table-pro [config]="config!" [currentPage]="pager.pageIndex" [currentPageSize]="pager.pageSize"
                [tableData]="recordList" (calcResultChange)="calcResultChange($event)"
                (firstSortOrderKeyChange)="firstSortOrderKeyChange($event)"
                (queryPanelStateChange)="queryPanelStateChange($event)" (resetClick)="resetSearch($event)"
                (searchClick)="searchClick($event)" (checkChange)="checkChange($event)" [stickyTop]="40"
                (afterEdit)="afterEdit($event)">
                <div class="grid overview">

                    <div class="row">
                        <div class="column">
                            <h3>交工检测方案</h3>
                        </div>
                    </div>
                    <div class="action-bar">
                        <button class="color-primary" nz-button nzType="text" (click)="add()" [disabled]="!canWrite">
                            + 交工检测方案
                        </button>
                    </div>
                </div>
            </table-pro>

        </div>

    </nz-content>
    <nz-footer class="footer">
        <nz-pagination [nzPageIndex]="pager.pageIndex" [(nzPageSize)]="pager.pageSize"
            [nzPageSizeOptions]="pager.pageSizeOptions" [nzTotal]="pager.total" nzShowQuickJumper
            [nzShowSizeChanger]="true" [nzShowQuickJumper]="true" (nzPageIndexChange)="pageIndexChange($event)"
            (nzPageSizeChange)="pageSizeChange($event)">
        </nz-pagination>
    </nz-footer>
</nz-layout>



<ng-template appHost></ng-template>